import { fromJS, Record } from 'immutable';
import getIn from 'immutable-less/transmute/getIn';
import ReenrollmentFilterOperation from 'automation-ui-enrollment/records/ReenrollmentFilterOperation';
import { areTimePointFiltersEqual } from 'automation-ui-enrollment/utils/timePointFilterUtils';
/*
This model needs to support different shapes of filters. For example `IN_LIST` filters and `PROPERTY` filters have two unique shapes. That is the reason why there are overloaded or optional properties like `listId` and two different properties to model `operator`/`operation`

A few CRM property models
https://git.hubteam.com/HubSpot/InboundDbListSeg/blob/master/docs/filters/IN_LIST.md
https://git.hubteam.com/HubSpot/InboundDbListSeg/blob/master/docs/filters/PROPERTY.md
*/
export default class ReenrollmentFilter extends Record({
  operation: null,
  operator: null,
  listId: null,
  property: null,
  filterType: null,
  objectTypeId: null
}, 'ReenrollmentFilter') {
  constructor(props) {
    const immutableProps = fromJS(props);
    super(Object.assign({}, props, {
      filterType: getIn(['filterType'], immutableProps),
      property: getIn(['property'], immutableProps),
      operation: new ReenrollmentFilterOperation(getIn(['operation'], immutableProps)),
      objectTypeId: getIn(['objectTypeId'], immutableProps)
    }));
  }
  getTrackingData() {
    // These must match fields in TOGGLE_ENROLLMENT_FILTER in events.yaml
    return {
      property: getIn(['property'], this),
      operation: getIn(['operation', 'operator'], this)
    };
  }
  isEqual(reenrollmentFilter) {
    const defaultValue = this.equals(reenrollmentFilter);
    return defaultValue || areTimePointFiltersEqual(this, reenrollmentFilter);
  }
}